import {Basic} from '@packages/systems/core/plugins';
import {px, percent} from '@packages/systems/core/utils/WebflowCssSubset';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  showEmpty: false,
  displayName: 'Image',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Image')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          width: px(60),
          height: percent(0),
        },
      },
    },
  },
  render: Atom.getConfigShape(Basic.atoms.Image).render,
  fields: {},
});

export default config;
